//components
import { showToaster } from "../Components/Toaster";

async function formResponse(res) {
    if (res.status === 200) {
        return res.clone().json().then(data => {
            if (data.code === 1000) return true;
            else showToaster('error', `Error code: ${data.code}`, data.msg);
        });
    }
    else showToaster('error', `Error code: ${res.status}`, 'Network call failed');
}

export default formResponse;